<template>
  <v-sheet class="card elevation-4 pa-4" id="js-reflection-entry-form">
    <span class="title" v-if="isEdit">Update Reflection</span>
    <span class="title" v-else>New Reflection</span>

    <v-text-field
      label="Title"
      id="js-reflection-title"
      v-model="reflection.title"
    ></v-text-field>

    <v-textarea
      label="Reflection Text"
      id="js-reflection-text"
      v-model="reflection.text"
    ></v-textarea>

    <v-btn text type="submit" class="md-primary" @click="submit">{{
      isEdit ? "Save" : "Create"
    }}</v-btn>
  </v-sheet>
</template>

<script>
import EventBus from "@/lib/eventBus"

export default {
  name: "ReflectionForm",
  props: {
    reflection: Object,
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    submit() {
      let eventName = this.isEdit ? "reflection:update" : "reflection:submit"
      let payload = {
        title: this.reflection.title,
        text: this.reflection.text
      }
      if (this.isEdit) {
        payload["id"] = this.reflection.id
      }
      EventBus.$emit(eventName, payload)
    }
  }
}
</script>

<style lang="css" scoped>
.card {
  width: 100%;
  max-width: 800px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}
.no-word-wrap {
  white-space: pre-line;
}
</style>
